<script setup lang="ts">
import {computed, ref} from "vue";
import {Tabs, TabsContent, TabsList, TabsTrigger} from "@/core/components/ui/tabs";
import {Badge} from "@/core/components/ui/badge";
import BaseButton from "@/core/components/base/BaseButton.vue";
import Icon from "@/core/components/icon/Icon.vue";
import CreditStoreModal from "@/credit/components/CreditStoreModal.vue";
import UpcomingSequenceMessagesTable from "@/rcs/components/scheduled/UpcomingSequenceMessagesTable.vue";
import NoCreditSequenceMessageInstancesTable from "@/rcs/components/scheduled/NoCreditSequenceMessageInstancesTable.vue";
import useUpcomingSequenceMessages from "@/notification-sequences/composables/useUpcomingSequenceMessages";
import useNotificationSequenceMessageInstances, {
    noCreditMessageInstanceFilters
} from "@/notification-sequences/composables/useNotificationSequenceMessageInstances";

const creditStoreModalVisible = ref(false);

const {data: upcoming} = useUpcomingSequenceMessages({page: 1, limit: 10});
const {data: noCredit} = useNotificationSequenceMessageInstances({...noCreditMessageInstanceFilters(), page: 1, limit: 10});

const upcomingCount = computed(() => upcoming.value?.meta?.total ?? 0);
const noCreditCount = computed(() => noCredit.value?.meta?.total ?? 0);
</script>

<template>
  <div class="p-4 flex flex-col gap-4">
    <div>
      <h1>RCS programmés</h1>
      <p>Les messages générés par vos séquences automatisées, à venir ou non envoyés.</p>
    </div>
    <Tabs default-value="upcoming" class="w-full">
      <TabsList>
        <TabsTrigger value="upcoming">
          À venir ({{ upcomingCount }})
        </TabsTrigger>
        <TabsTrigger value="no_credit" class="flex items-center gap-2">
          Non envoyés
          <Badge v-if="noCreditCount > 0" variant="destructive">
            {{ noCreditCount }}
          </Badge>
        </TabsTrigger>
      </TabsList>
      <TabsContent value="upcoming">
        <UpcomingSequenceMessagesTable />
      </TabsContent>
      <TabsContent value="no_credit" class="flex flex-col gap-4">
        <div
          v-if="noCreditCount > 0"
          class="flex flex-col gap-4 bg-red-50 border border-red-200 rounded-lg p-4 sm:flex-row sm:items-center"
        >
          <div class="flex items-center gap-3 min-w-0">
            <Icon name="mdi-close-circle" color="red" :size="24" class="shrink-0" />
            <p class="text-red-700 text-sm">
              Ces envois ont été annulés faute de crédits SMS.
              Rechargez vos crédits pour que vos prochains messages soient bien envoyés.
            </p>
          </div>
          <BaseButton
            color="error"
            class="shrink-0 self-start sm:self-auto sm:ml-auto"
            @click="creditStoreModalVisible = true"
          >
            Acheter des crédits
          </BaseButton>
        </div>
        <NoCreditSequenceMessageInstancesTable />
      </TabsContent>
    </Tabs>
    <CreditStoreModal v-if="creditStoreModalVisible" @close="creditStoreModalVisible = false" />
  </div>
</template>
